import(/* webpackMode: "eager", webpackExports: ["ClientLanguageProvider"] */ "/builds/developers/frontend/node_modules/@inlang/paraglide-next/dist/paraglide-next/src/app/providers/ClientLanguageProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/builds/developers/frontend/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/builds/developers/frontend/node_modules/@tanstack/react-query/build/modern/isRestoring.js");
;
import(/* webpackMode: "eager" */ "/builds/developers/frontend/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/builds/developers/frontend/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/builds/developers/frontend/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/builds/developers/frontend/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/builds/developers/frontend/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/builds/developers/frontend/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/builds/developers/frontend/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/builds/developers/frontend/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/builds/developers/frontend/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/builds/developers/frontend/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/builds/developers/frontend/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
;
import(/* webpackMode: "eager" */ "/builds/developers/frontend/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/builds/developers/frontend/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/builds/developers/frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/builds/developers/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/builds/developers/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/builds/developers/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/developers/frontend/src/app/_providers/event-processor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChangeLanguage"] */ "/builds/developers/frontend/src/features/change-language/ui/change-language.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChangeTheme"] */ "/builds/developers/frontend/src/features/change-theme/ui/ChangeTheme.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectName"] */ "/builds/developers/frontend/src/shared/ui/layout/project-layout/project-name.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/builds/developers/frontend/src/shared/ui/link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarProvider","SidebarTrigger"] */ "/builds/developers/frontend/src/shared/ui/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BalanceDisplay"] */ "/builds/developers/frontend/src/widgets/balance-display/ui/balance-display.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppSidebar"] */ "/builds/developers/frontend/src/widgets/main-sidebar/ui/app-sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarketplaceTypeChip"] */ "/builds/developers/frontend/src/widgets/marketplace-type-chip/ui/marketplace-type-chip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileSheetMenu"] */ "/builds/developers/frontend/src/widgets/mobile-sheet-menu/ui/mobile-sheet-mentu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StatusLoad"] */ "/builds/developers/frontend/src/widgets/project-controller/ui/status-load.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SecondarySidebar"] */ "/builds/developers/frontend/src/widgets/secondary-sidebar/ui/secondary-sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserMenu"] */ "/builds/developers/frontend/src/widgets/user-menu/ui/user-menu.tsx");
